import { atom, selector } from 'recoil';
import enText from '../language/en.json';
import koText from '../language/ko.json';

export const languageSetting = atom({
	key: 'languageSetting',
	default: 'ko',
});

export const translatedText = selector({
	key: 'translatedText',
	get: ({ get }) => {
		const language = get(languageSetting);

		if (language === 'en') return enText;
		else if (language === 'ko') return koText;
		else return {};
	},
});
